import gql from "graphql-tag";

export const logImageErrors = gql`
  mutation LogImageErrors($imageUrl: String!, $productId: String) {
    logImageErrors(imageUrl: $imageUrl, productId: $productId) {
      status
    }
  }
`;
